<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <audio id="Prompt" src="/static/basicimg/Prompt.mp3" controls="controls" hidden="true" preload="preload">
    </audio>
  </div>
</template>

<script>
import router from "./router";
import EnvBase from "./env.js";
import SvrApi from "./svrapi.js";
import wsc from '../src/vendor/qnbar/msgWsClient';
import { ws_base } from '../src/http/ws_base'
import { mapState, mapGetters } from 'vuex'

var PT = EnvBase.PT;

export default {
  name: "mainPage",
  provide () { // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data: function() {
    return {
      agent_id: ""
    };
  },

  beforeMount: function() {
    // 平台
    const self = this;
    //--------- 固定统一登录初始化流程 ---------

    var withLocalSessClean = PT.qnlogin.findGetParameter("local_sess_clean");
    if (withLocalSessClean) {
      PT.apiClient.blockQuery();
    }

    //登录模块的配置和初始化
    var LoginRunConf = {};

    //本地session ok时执行
    function OnLocalSessionOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk;
    }
    //没有本地session时执行, 注意不是完全没有，可能带ticket或tgc...
    function OnLocalSessionNotOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk;
    }

    //平台本地ticket校验并返回session的接口
    function OnHasTicketDoFunc(ticket) {
      var postParams = {
        service_ticket: ticket
      };
      PT.apiClient.query(
        SvrApi.loginValidateTicket,
        postParams,
        PT.qnlogin.handleTicketValidate
      );
      PT.apiClient.blockQuery();
    }

    function OnSessionFailDoFunc() {
      //本地和passport都失败，完全没有session
      // console.log("OnSessionFailDoFunc");
      PT.apiClient.blockQuery();
      self.jumpLogin();
    }

    //避免无失败卡页面
    function OnTicketValidateFailFunc() {
      alert("登录ticket验证失败！请尝试重新登录");
      PT.qnlogin.logout();
      this.hasLogin = PT.qnlogin.isLocalSessOk;
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    }

    //----------- 外部执行带入登录工具的配置 ------------
    LoginRunConf.JumpBackUrl = PT.config.loginJumpBackUrl; //登录回跳地址
    LoginRunConf.OnLocalSessionOkDo = OnLocalSessionOkDoFunc;
    LoginRunConf.OnLocalSessionNotOkDo = OnLocalSessionNotOkDoFunc;
    LoginRunConf.OnHasTicketDo = OnHasTicketDoFunc;
    LoginRunConf.OnSessionFailDo = OnSessionFailDoFunc;
    LoginRunConf.OnTicketValidateFail = OnTicketValidateFailFunc;

    //---- 登录ok后的执行和鉴权的执行 ----

    //权限检查对象
    //全局 - 获取当前登录用户的全量权限code
    function checkAllUserPermission() {
      //开始执行鉴权请求
      PT.apiClient.blockQuery();
      PT.permissionChecker.queryAllPermissions(
        PT.apiClient,
        PT.config.platformUsagespace,
        PT.qnlogin.getLocalSess(),
        onAllPermissionQueryOK,
        onAllPermissionQueryFail
      );
    }

    //全局 - 登录OK后执行内容
    function onPageSessionOk() {
      self.user_title = "读取中...";
      self.hasLogin = PT.qnlogin.isLocalSessOk;
      //有登录，就执行权限获取
      checkAllUserPermission();
    }

    //执行passport登录模块的页面初始化运行过程
    LoginRunConf.OnAfterLocalSessionOkDo = onPageSessionOk;
    PT.qnlogin.runInPageReady(LoginRunConf);

    function onAllPermissionQueryOK() {
      //勿动~
      //PT.apiClient.resumeQuery();

      var data = PT.permissionChecker.hasPermission("local_user_base_module");
      eventBus.$emit("Jurisdiction", data); //判断权限

      PT.apiClient.query(
        SvrApi.loginUserInfo,
        "",
        function(rsp) {
          if (rsp.code == 0) {
            //debugger;
            // console.log("app请求");
            self.$store.commit("SET_USER_INFO", rsp.data);
            self.commonSetLocalDataNew("identity", JSON.stringify(rsp.data));
            // console.log(rsp);
            self.getUserInfo();
            self.$store.dispatch('setAuth')
          } else {
            alert("获取用户信息错误！");
          }
        },
        null,
        "",
        true
      );
    }

    function onAllPermissionQueryFail() {
      alert("请求权限失败，请尝试重新登录...");
      PT.qnlogin.logout();
      this.hasLogin = PT.qnlogin.isLocalSessOk;
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    }
  },

  mounted: function() {
    //内容审核
    // const setTime = setTimeout(() => {
    //   this.$store.dispatch('getWhiteListType')
    //   this.$store.dispatch('getExamineRemind')
    //   //清除定时器
    //   clearTimeout(setTime);
    // },1000)
    const self = this;

    //【业务逻辑入口改到这里了！！！】
    // 获取待配送订单
    self.getWaitOrder=function() {
      PT.apiClient.query(
        SvrApi.getOrderList, {type: 3}, function(rsp) {
          if(rsp.code == 0) {
            self.$store.commit("SET_WAIT_ORDER", rsp.data)
            handleWs()
          }else {
            alert('待配送订单获取错误！')
          }
        }
      )
    }

    // 获得权限
    Notification.requestPermission();

    // 3秒拉取一次投影仪服务请求
    // var timer = setInterval(getRemindMsg, 3000);
    // function getRemindMsg() {
    //   PT.apiClient.query(SvrApi.waitDistribution, {}, function(rsp) {
    //     if (rsp.code == 0) {
    //       if (rsp.data.is_notic > 0) {
    //         self.$store.commit("GET_ISORDER_DATA", true);
    //         showDeskTopNotice("待配送数量", rsp.data.num);
    //       }
    //     } else {
    //       self.$alert(rsp.msg, "提示");
    //       clearInterval(timer);
    //     }
    //   });
    // }
    function showDeskTopNotice(title, msg) {
      var Notification =
        window.Notification ||
        window.mozNotification ||
        window.webkitNotification;
      if (Notification) {
        Notification.requestPermission(function(status) {
          // console.log('status: ' + status)
          //status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
          if ("granted" != status) {
            return;
          } else {
            var tag = "qnbar" + Math.random();
            var notify = new Notification(title, {
              dir: "auto",
              lang: "zh-CN",
              tag: tag, //实例化的notification的id
              icon:
                "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80", //通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
              body: msg //通知的具体内容
            });
            (notify.onclick = function() {
              //如果通知消息被点击,通知窗口将被激活
              window.focus();
            }),
              (notify.onerror = function() {
                // console.log("HTML5桌面消息出错！！！");
              });
            notify.onshow = function() {
              // setTimeout(function(){
              //     notify.close();
              // },2000)
            };
            notify.onclose = function() {
              // console.log("HTML5桌面消息关闭！！！");
            };
          }
        });
      } else {
        alert("您的浏览器不支持桌面消息");
      }
    }

    // ----------- 执行一个全局或当前页的websocket -----------
    function handleWs() {
      // ---- 1.身份绑定 -----
      // 测试内容: 商户页面通知业务
      // 门店序号绑定
      // sn = agent_id
      let storeSn = self.agent_id + "@MM.STORE"; // sn@group
      // console.log(storeSn)
      // 业务-组和序号 的绑定
      let bzAndIdBindMap = new Map();
      bzAndIdBindMap.set(ws_base.BZ_MCH_WEB_NTF, storeSn);
      bzAndIdBindMap.set(ws_base.BZ_HOTEL_ROOM_MGR, storeSn);
      bzAndIdBindMap.set(ws_base.AGENT_WEB_MSG, storeSn);
      // ---- 2.业务处理器绑定 ----
      // 测试内容: 商户页面通知业务
      // 对收到的消息进行处理
      let bzMchWebNtfDealer = function(protoMsg) {
          // todo 这里最好也配置化然后处理
          window.eventBus.$emit(protoMsg.getOp(), JSON.parse(protoMsg.getBzdata())) // 发送事件
          if (protoMsg.getOp() == "prjt_retail_ntf") { // 投影商品购买通知...
              if (protoMsg.getBzdata()) {
                  // console.log(protoMsg.getBzdata());
                  let data = JSON.parse(protoMsg.getBzdata());
                  let sendData = {
                      total: data.num
                    }
                  if(data.type == 1) {
                     var Prompt = document.getElementById("Prompt");
                     Prompt.play();
                     showDeskTopNotice("待配送数量", data.num);
                     self.$store.commit('SET_WAIT_ORDER', sendData)
                     self.$store.commit("GET_ISORDER_DATA", true);
                  }else if(data.type == 2) {
                    self.$store.commit('SET_WAIT_ORDER', sendData)
                    self.$store.commit("GET_ISORDER_DATA", true);
                  }else {
                    // console.log('error')
                  }
              } else {
                  // console.log("?????");
              }
          }
      // 如果当前路由无法处理，使用其他形式传达通知
      }
      let bzMchHotelRoomMgr = function(protoMsg) {
        window.eventBus.$emit(protoMsg.getOp(),protoMsg.getBzdata()) // 发送事件
      }
      let bzMsgDealerMap = new Map();
      bzMsgDealerMap.set(ws_base.BZ_MCH_WEB_NTF, bzMchWebNtfDealer);
      bzMsgDealerMap.set(ws_base.BZ_HOTEL_ROOM_MGR, bzMchHotelRoomMgr);
      bzMsgDealerMap.set(ws_base.AGENT_WEB_MSG, bzMchHotelRoomMgr);

      // ---- 3.鉴权信息获取 ----
      let PT_NAME = PT.config.platformUsagespace;
 
      // ---- 4.初始化并启动客户端 ----
      wsc.MsgWsClient.init({
          proto: PT.config.wsProto,
          host : PT.config.wsHost,                 // 必填
          port : PT.config.wsPort,                 // 必填
          path : ws_base.wsPath,                 // 必填
          authSys : PT_NAME,                     // 必填 项目配置中的平台字符串
          authKey : PT.qnlogin.getLocalSess(),   // 必填 本地系统的session key/token
          toBindMap : bzAndIdBindMap,            // 必填
          bzMsgDealerMap : bzMsgDealerMap,       // 必填
          //debug : true,
      });
      wsc.MsgWsClient.startRun();
      const obj = {
        proto: PT.config.wsProto,
        host : PT.config.wsHost,                 // 必填
        port : PT.config.wsPort,                 // 必填
        path : ws_base.wsPath,                 // 必填
        authSys : PT_NAME,                     // 必填 项目配置中的平台字符串
        authKey : PT.qnlogin.getLocalSess(),   // 必填 本地系统的session key/token
        toBindMap : bzAndIdBindMap,            // 必填
        bzMsgDealerMap : bzMsgDealerMap,       // 必填
      }
      console.log(obj)
      // ------- 发送消息功能暂时禁用中 -------
      // test send a msg to self
      // wsc.MsgWsClient.sendMsg(BZ_MCH_WEB_NTF, "prjt_retail_ntf", "test send and receive self", storeSn);
      // test send a msg to projector
      // wsc.MsgWsClient.sendMsg(BZ_PRJT_TXT_MSG, "send_msg", "hello!!!", "2@p");
    }
  },

  data: function() {
    return {
      hasLogin: false,
      user_title: "未登录",
      agent_id: "",
      isRouterAlive: true // 控制视图是否显示的变量
    };
  },

  methods: {
    // -- 这坨是登录的 --
    handleCheckLoginInfoFail() {
      //单一用户类型，直接进入登录
      PT.qnlogin.jumpToCheck(PT.config.loginJumpBackUrl, "merchant"); //official_staff 官方运营人员  /  agent 合作商  /  merchant 商户 /  merchant_staff 员工
      this.hasLogin = PT.qnlogin.isLocalSessOk;
    },

    // 跳转登录身份
    jumpToLoginChoose(){
      var self = this;
      self.$router.push({ path: "/login" });
    },

    handleOnLogout(rsp) {
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    },

    jumpLogin() {
      //console.log('jumpLogin');
      PT.qnlogin.firstCheck(
        PT.config.loginJumpBackUrl,
        // this.handleCheckLoginInfoFail
        this.jumpToLoginChoose
      );
    },

    runLogout() {
      var postParams = {
        local_sess: PT.qnlogin.getLocalSess()
      };
      PT.apiClient.query(SvrApi.logout, postParams, this.handleOnLogout);
      PT.qnlogin.logout();

      this.hasLogin = PT.qnlogin.isLocalSessOk;
    },

    // -- 这坨是菜单的 --
    goPage(routePath) {
      //todo 先鉴权
      this.$router.push(routePath);
    },
    reload () {
      this.isRouterAlive = false // 先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true // 再打开
      }) 
    },
    //判断酒店足浴
    getUserInfo: function() {
      var self = this;
      PT.apiClient.query(
        "bz-mix/bz/get-base-info",
        "",
        function(rsp) {
          if (rsp.code == 0) {
            self.agent_id = rsp.data.agent_id;
            // 属于新起点门店
            if (['5', '6'].includes(rsp.data.group_id)) {
              // 登出
              return self.runLogout()
            }
            if(rsp.data.agentType!=1&&rsp.data.agentType!=2){
              self.getWaitOrder();
            }
            // console.log("设置数据")
            // console.log("设置数据")
            // console.log(self.commonSetLocalDataNew)
            self.commonSetLocalDataNew("user_data", JSON.stringify(rsp.data));
            self.$store.commit("SET_ROUTE", rsp.data);
            var opendata = {
              store_id: rsp.data.agent_id,
              type: 1,
              operation: 3
            };
            // self.getIsopen(opendata);
            //旧
            self.$store.commit("GET_NAVBAR_DATA", rsp.data);
            //存储酒店足浴
            self.$store.commit("SET_HOTEL_OR_FOOTBATH", rsp.data);
            //globalData.agentType = rsp.data.agentType;//5代表酒店7代表足浴
            if (!!rsp.data.agentType && rsp.data.agentType == 5) {
              //eventBus.$emit('user_title', "酒店");
              self.$store.commit("SET_USER_TITLE", "酒店");
            } else if (!!rsp.data.agentType && rsp.data.agentType == 7) {
              //eventBus.$emit('user_title', "足浴");
              self.$store.commit("SET_USER_TITLE", "足浴");
            } else {
            }

            PT.apiClient.resumeQuery();
          } else {
            alert("获取用户信息错误！!");
          }
        },
        null,
        "",
        true
      );
    },
    // getIsopen(data) {
    //   PT.apiClient.query(
    //     SvrApi.queryOpen,
    //     data,
    //     function(rsp) {
    //       if (rsp.code == 0) {
    //         // console.log(rsp.data.is_open)
    //         localStorage.setItem("isopen",JSON.stringify(rsp.data));
    //       } else {
    //         self.$alert(res.msg, "提示");
    //       }
    //     },
    //     null,
    //     "",
    //     true
    //   );
    // }
   
  },
  computed:{
     ...mapGetters([
      'the_agent_id'
    ])
  }
  //组件实例创建完成
  // created:function(){
  //   const aaa = this.$loading({
  //     fullscreen: true,
  //     text:"拼命加载中..."
  //   });

  //   setTimeout(function(){
  //       aaa.close()
  //   },1000)
  // },
  // watch:{
  // }
};
</script>

<style lang="scss">
@import "../static/css/main.css";
@import "../static/css/color-background.css";
@import "vendor/qnbar/style.css";

@import "~normalize.css/normalize.css"; // normalize.css 样式格式化
@import "./styles/index.scss"; // 全局自定义的css样式
.roomcontainer .el-form-item__label {
  width: 120px !important;
}
.roomcontainer .el-form-item__content {
  margin-left: 120px !important;
}
.roomcontainer .el-dialog--tiny {
  width: 40%;
}
.otherC .inputC .el-select > .el-input {
  margin: 5px 0;
}
.orderlistC .top .el-input__inner {
  display: inline-block !important;
}
.el-table th > .cell {
  text-align: center;
}
.el-table .cell {
  text-align: center !important;
}
#interfaceDetail .el-table__body-wrapper{
  overflow: hidden;
}
#interfaceDetail .el-table__body{
  min-height: 60px;
}
#interfaceDetail .el-table td{
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?0025017b